import { Component } from '@angular/core';
import { DocumentService } from 'src/app/services/document.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

  ies: any;

  constructor(
    private document: DocumentService
  ) {
    this.ies = this.document.getIES();
  }

  ngOnInit(): void {
    // Define a IES
    sessionStorage.setItem('ies', JSON.stringify(this.ies));
  }

}
